import { STORAGE_KEYS } from "../constants/storageKeys";
import Tool from "../utils/tool";
const DEFAULT_JAVA_API_URL = "https://micro-api-test.kidcastle.com.cn/gw/jdb-school-crm";
export const LOGIN_PATH = "/Login";
const PHP_ONLY_PATHS = new Set(["/Login", "/Index/getSchoolApi"]);
const DOUBLE_TIMEOUT_PATHS = new Set(["/Client/migrationCrmApi"]);

/** 学校列表等多条记录接口：响应里有多校 school_isgrayscalecrm，不可用来覆盖「当前校」本地标志 */
const PHP_PATHS_SKIP_GRAY_FLAG_EXTRACT = new Set(["/Index/getSchoolApi"]);

export function shouldSaveGraySchoolFlagForPhpPath(pathname) {
  return !PHP_PATHS_SKIP_GRAY_FLAG_EXTRACT.has(pathname);
}

function stripTrailingSlash(value) {
  return value.endsWith("/") ? value.slice(0, -1) : value;
}

function parseUrl(url) {
  if (!url || typeof url !== "string") {
    return { origin: "", pathname: "", search: "" };
  }
  try {
    const parsed = new URL(url, window.location.origin);
    return {
      origin: parsed.origin,
      pathname: parsed.pathname,
      search: parsed.search,
    };
  } catch (e) {
    return { origin: "", pathname: "", search: "" };
  }
}

function isPhpOnlyPath(pathname) {
  return PHP_ONLY_PATHS.has(pathname);
}

export function shouldDoubleRequestTimeout(pathname) {
  return DOUBLE_TIMEOUT_PATHS.has(pathname);
}

export function isLoginPath(pathname) {
  return pathname === LOGIN_PATH;
}

export function toGraySchoolValue(value) {
  if (value === 1) return 1;
  if (value === 0) return 0;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "1") return 1;
    if (trimmed === "0") return 0;
  }
  if (value === true) return 1;
  if (value === false) return 0;
  return null;
}

export function isGraySchoolEnabled() {
  return toGraySchoolValue(Tool.getStorage(STORAGE_KEYS.IS_GRAY_SCHOOL)) === 1;
}

export function extractGraySchoolFlag(payload) {
  const visited = new Set();

  function walk(target, depth) {
    if (depth > 8 || target == null) return null;
    if (typeof target !== "object") return null;
    if (visited.has(target)) return null;
    visited.add(target);

    const direct = toGraySchoolValue(target.school_isgrayscalecrm);
    if (direct !== null) return direct;

    if (Array.isArray(target)) {
      for (let i = 0; i < target.length; i += 1) {
        const value = walk(target[i], depth + 1);
        if (value !== null) return value;
      }
      return null;
    }

    const keys = Object.keys(target);
    for (let i = 0; i < keys.length; i += 1) {
      const value = walk(target[keys[i]], depth + 1);
      if (value !== null) return value;
    }
    return null;
  }

  return walk(payload, 0);
}

export function saveGraySchoolFlag(payload, Tool, fallbackValue = null) {
  const grayValue = extractGraySchoolFlag(payload);
  if (grayValue !== null) {
    Tool.setStorage(STORAGE_KEYS.IS_GRAY_SCHOOL, grayValue);
    return;
  }
  const fallback = toGraySchoolValue(fallbackValue);
  if (fallback !== null) {
    Tool.setStorage(STORAGE_KEYS.IS_GRAY_SCHOOL, fallback);
  }
}

export function resolveRequestMeta(config, Urls) {
  const parsed = parseUrl(config.url);
  const crmBase = parseUrl(Urls.crmApiUrl);
  const isCrmApi = Boolean(parsed.origin && crmBase.origin && parsed.origin === crmBase.origin);
  const isPhpOnly = isPhpOnlyPath(parsed.pathname);

  return {
    pathname: parsed.pathname,
    search: parsed.search,
    isCrmApi,
    isPhpOnly,
  };
}

export function buildJavaUrl(pathname, search, Urls) {
  const javaBaseUrl = Urls.crmJavaApiUrl || DEFAULT_JAVA_API_URL;
  const normalizedBase = stripTrailingSlash(javaBaseUrl);
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${normalizedBase}${normalizedPath}${search || ""}`;
}

/**
 * 导出接口使用 window.open，无法走 axios 拦截器。
 * 灰度校时需手动将 PHP base URL 替换为 Java base URL。
 */
export function buildExportUrl(fullUrl, Urls, Tool) {
  if (!isGraySchoolEnabled(Tool)) return fullUrl;
  const phpBase = stripTrailingSlash(Urls.crmApiUrl || "");
  const javaBase = stripTrailingSlash(Urls.crmJavaApiUrl || DEFAULT_JAVA_API_URL);
  if (phpBase && fullUrl.startsWith(phpBase)) {
    return javaBase + fullUrl.slice(phpBase.length);
  }
  return fullUrl;
}
